import { useEffect, useState } from 'react';
import { CardMedia, Checkbox, IconButton } from '@mui/material';

import { useAuth } from '../../providers/AuthProvider';
import { NEW_COLLECTION_PATH } from '../../constants';
import Navbar from '../children/Navbar';
import { BodyDiv, ButtonsRow, Button, Card, CardContent, CardsRow, CenterBox, Header, ImgCheckbox, LinkPurple,
  GrayNavContainer, DividerVert, PhotoCards, RowDiv, Text } from '../../styles/styles';
import PhotoCardsImg from '../../imgs/photo-cards.svg';
import CollectionService from '../../services/collectionService';
import { Close, DeleteOutlineOutlined } from '@mui/icons-material';

const Home = () => {
  const { currentUser } = useAuth();
  const [collections, setCollections] = useState<PhotoCollection[]>([]);
  const [selectMode, setSelectMode] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [selectedColIds, setSelectedColIds] = useState<string[]>([]);

  const handleNewCollectionClick = () => {
    window.location.assign(NEW_COLLECTION_PATH);
  }

  const fetchCollections = async () => {
    const collections = await CollectionService.getAllUserCollections(currentUser?.uid);
    setCollections(collections);
  }

  const handleImgClick = async (collectionId: string) => {
    if (!selectMode) {
      window.location.assign(`collection/${collectionId}`)
      return;
    }
    if (selectedColIds.includes(collectionId)) {
      setSelectedColIds(selectedColIds.filter(id => id !== collectionId));
    } else {
      setSelectedColIds([...selectedColIds, collectionId]);
    }
  }

  const handleCancelClick = () => {
    setSelectMode(false);
    setSelectedColIds([]);
    setIsAllSelected(false);
  }

  const handleSelectAll = () => {
    if (selectedColIds.length === collections?.length) {
      setSelectedColIds([]);
      setIsAllSelected(false);
      return;
    }
    setSelectedColIds(collections.map(col => col.id));
    setIsAllSelected(true);
  };

  const handleDeleteCollection = () => {
  };

  const handleSelectModeClick = () => {
    setSelectMode(true);
  }

  useEffect(() => {
    if (currentUser) {
      fetchCollections();
    }
  }, [currentUser]);

  return (<>
    <Navbar />
    <BodyDiv>
      {currentUser &&
        <>
          {collections?.length === 0 &&
            <CenterBox>
              <PhotoCards src={PhotoCardsImg} />
              <Header style={{ textAlign: "center" }}>0 collections to display</Header>
              <Text style={{ color: "#757575", lineHeight: "20px", letterSpacing: "0.25px" }}>Upload your photos to create your first collection!</Text>
              <Button onClick={handleNewCollectionClick} style={{ marginTop: "24px" }}>New Collection</Button>
            </CenterBox>
          }
          {collections?.length > 0 &&
            <>
              <RowDiv>
                <Header style={{ marginBottom: "48px" }}>My Collections</Header>
                {selectMode ?
                  <GrayNavContainer style={{ marginBottom: "0px", gap: "100px" }}>
                    <RowDiv style={{ gap: "12px" }}>
                      <IconButton onClick={handleCancelClick}><Close style={{ color: "#1E1E1E" }} /></IconButton>
                      <Text style={{ whiteSpace: 'nowrap', color: "#1E1E1E" }}>{selectedColIds?.length} Selected</Text>
                    </RowDiv>
                    <RowDiv style={{ gap: "15px" }}>
                      <RowDiv>
                        <Checkbox checked={isAllSelected} onChange={handleSelectAll} style={{ color: "#A20B91" }} />
                        <Text onClick={handleSelectAll} style={{ whiteSpace: 'nowrap', color: "#1E1E1E", cursor: "pointer" }}>Select all</Text>
                      </RowDiv>
                      <DividerVert />
                      <ButtonsRow>
                        {/* <IconButton><SaveAlt style={{ color: "#A20B91" }} /></IconButton> */}
                        <IconButton onClick={handleDeleteCollection}><DeleteOutlineOutlined style={{ color: "#A20B91" }} /></IconButton>
                      </ButtonsRow>
                    </RowDiv>
                  </GrayNavContainer>
                  :
                  <LinkPurple onClick={handleSelectModeClick} style={{ padding: "10px 24px" }}>Select</LinkPurple>
                }
              </RowDiv>
              <CardsRow>
                {collections.map(collection => (
                  <Card onClick={() => handleImgClick(collection?.id)} key={collection?.id} checked={selectedColIds.includes(collection?.id)} selecting={selectMode}>
                    <ImgCheckbox className="checkbox" checked={selectedColIds.includes(collection?.id)} />
                    <CardMedia component="img" height="200" image={collection?.thumbnailUrl} alt={collection?.title} sx={{ filter: 'brightness(0.85)' }} />
                    <CardContent>
                      <Header>{collection?.title}</Header>
                      <Text>{collection?.totalPhotos} Images</Text>
                    </CardContent>
                  </Card>
                ))}
              </CardsRow>
            </>
          }
        </>
      }
      {!currentUser &&
        <CenterBox>
          <Header>Welcome to Cureyta!</Header>
          <Text>Upload your photos to create your first collection!</Text>
          <Button onClick={handleNewCollectionClick} style={{ marginTop: "24px" }}>New Collection</Button>
        </CenterBox>
      }
    </BodyDiv>
    </>
  );
};

export default Home;
